import React, { useState } from 'react';
import { Checkbox } from 'antd';
import './styles.css';
import { CheckboxProps } from 'antd/lib/checkbox';

export const RBHCheckBox = (props: CheckboxProps) => {
    const [checked, setChecked] = useState<boolean>(props.checked || false);
    const handleOnChange = (e: any) => {
        setChecked(!checked);
        props.onChange && props.onChange(e);
    };
    return (
    <Checkbox {...props} id={props.id} checked={checked} value={props.value} onChange={handleOnChange} />
  );
};

export default RBHCheckBox;
